export default __webpack_public_path__ + "static/media/music_enabled.2c737e61.svg";